
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/inizio-stagione-sciistica",
      function () {
        return require("private-next-pages/[region]/inizio-stagione-sciistica.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/inizio-stagione-sciistica"])
      });
    }
  